import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 position-relative" }
const _hoisted_2 = ["value", "min", "max", "step"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "range-fill",
      style: _normalizeStyle(`width: calc((100% - 16px) * ${_ctx.modelValue / 100} + 8px)`)
    }, null, 4),
    _createElementVNode("input", {
      type: "range",
      class: "form-range w-100 custom-range",
      style: {"height":"4px"},
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleRangeChange && _ctx.handleRangeChange(...args))),
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleRangeCommit && _ctx.handleRangeCommit(...args))),
      onPointerdown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDragStart && _ctx.handleDragStart(...args))),
      onPointerup: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDragEnd && _ctx.handleDragEnd(...args))),
      onPointercancel: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleDragCancel && _ctx.handleDragCancel(...args))),
      value: _ctx.modelValue,
      min: _ctx.min,
      max: _ctx.max,
      step: _ctx.step
    }, null, 40, _hoisted_2)
  ]))
}